import { BaseColumnDetails } from '../../../../grid/types/common';
import { LicenseRenderers } from '../../../../company/common/licenseRenderers/LicenseRenderers';
import {
  LicenseProductStatus,
  LicenseUsage,
} from '../../../../company/common/licensingGrid/types/licensing-grid-license';
import { SubscriptionType } from '../../../../license/types/SubscriptionType';
import { gridCustomHtmlRenderer } from '../../../../grid/utils/renderers';

export function getColumns(translateFn): BaseColumnDetails[] {
  return [
    {
      key: 'indentationColumn',
      name: '',
      frozen: true,
      width: '68px',
    },
    {
      key: 'productId',
      name: translateFn('Product name'),
    },
    {
      key: 'productType',
      name: translateFn('Product type'),
    },
    {
      key: 'productStatus',
      name: translateFn('Product status'),
    },
    {
      key: 'licenseKey',
      name: translateFn('License key'),
    },
    {
      key: 'expiryDate',
      name: translateFn('Expiry date'),
    },
    {
      key: 'totalSeats',
      name: translateFn('Total seats'),
    },
    {
      key: 'usageBreakdown',
      name: translateFn('Usage breakdown'),
    },
  ];
}

export function getRenderers(translateFn, timezone: string) {
  return {
    indentationColumn: () => {
      return '';
    },
    productId: (
      _,
      columnInfo,
      rowData: unknown & {
        item: LicenseUsage & {
          subscription: SubscriptionType;
        };
      }
    ) => {
      const license = rowData.item;
      const productId = license.productId;

      return LicenseRenderers.getTranslatedProductName(
        license.isMonthly ?? false,
        license.isInheriting ?? false,
        license.hasBasicMonthly ?? false,
        productId
      );
    },
    productType: (
      _,
      columnInfo,
      rowData: unknown & {
        item: LicenseUsage & {
          subscription: SubscriptionType;
        };
      }
    ) => {
      const license = rowData.item;
      const subscription = rowData.item.subscription;

      switch (subscription) {
        case SubscriptionType.Frat:
          return translateFn('Standard');
        case SubscriptionType.BasicMonthly:
        case SubscriptionType.MonthlyLicenseTrial:
        case SubscriptionType.InheritedMspTrial:
          return 'Endpoint Security';
      }

      return LicenseRenderers.getTranslatedProductType(
        license.isMonthly ?? false,
        license.isAddon ?? false,
        license.productType
      );
    },
    productStatus: (
      _,
      columnInfo,
      rowData: unknown & {
        item: LicenseUsage & {
          subscription: SubscriptionType;
        };
      }
    ) => {
      return LicenseRenderers.renderProductStatus(rowData.item.productStatus);
    },
    expiryDate: (
      _,
      columnInfo,
      rowData: unknown & {
        item: LicenseUsage & {
          subscription: SubscriptionType;
        };
      }
    ) => {
      const expiryDate = rowData.item.expiryDate;
      return LicenseRenderers.renderExpiryDate(expiryDate, timezone);
    },
    totalSeats: (
      _,
      columnInfo,
      rowData: unknown & {
        item: LicenseUsage & {
          subscription: SubscriptionType;
        };
      }
    ) => {
      return LicenseRenderers.renderTotalSeats(rowData.item);
    },
    usageBreakdown: (
      _,
      columnInfo,
      rowData: unknown & {
        item: LicenseUsage & {
          subscription: SubscriptionType;
        };
      }
    ) => {
      return gridCustomHtmlRenderer(LicenseRenderers.renderUsageBreakdown(rowData.item));
    },
  };
}
